import React, { Component } from 'react'
import './_styles.scss'
import Utils from '../../../../../utils/Utils'
import Translator from '../../../../../requests/apa/Translator'

class NoData extends Component {
    constructor (props) {
        super(props)
    }

    render () {
        return (
            <div className='estadisticas-juegos__empty-message-container'>
                <p className='estadisticas-juegos__empty-message-text'>{Utils.cutPlayerString(Translator.get('eventodeportivo_estadisticajuegos_texto_nohaydatos'),60)}</p>
            </div>
        )
    }
}


export default NoData



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/Components/NoData/index.jsx